module.exports = __webpack_public_path__ + "assets/img/no-image.9b60aeef.png";